/*
 * This code was copied over from the Mono Repo Common-Library
 * TODO: When the Common-Library gets exported to npm,
 * - Remove this file
 * - Update components to use npm package instead of this file
 *
 */
import { QueryValueObj } from "./buildAndCleanQueryString";

export default function cleanInitialStateFromQuery(
  browserHistory: QueryValueObj,
  dashToSlash: string[]
) {
  const copyBrowserHistory = { ...browserHistory };
  dashToSlash.forEach(item => {
    if (copyBrowserHistory[item]) {
      copyBrowserHistory[item] = copyBrowserHistory[item].replace(/-/g, "/");
    }
  });
  return copyBrowserHistory as QueryValueObj;
}
